<p-toast>
  <ng-template
    let-message
    pTemplate="message"
  >
    <app-vyv-toast [message]="message"></app-vyv-toast>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
